// extracted by mini-css-extract-plugin
export default {"skeleton-row":"SkeletonRow_skeleton-row__YOPQh","skeleton-btn":"SkeletonRow_skeleton-btn__r+qQ4"};